export default __webpack_public_path__ + "static/media/print.3c78d3ef.svg";